import React, { useState, useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import CalendarComponent from "../Calendar/Calendar.js";
import Settings from "../Settings/Settings.js";
import Data from "../Data/Data.js";
import Invoice from "../Invoice/Invoice.js";
import NewPassword from "../NewPassword/NewPassword.js";
import Treatments from "../Treatments/Treatments.js";
import Course from "../Course/Course.js";
import Cowork from "../Cowork/Cowork.js";
import API from "../../actions";

import OnlineBookingSettings from "../OnlineBookingSettings/OnlineBookingSettings.js";
import ContactClients from "../Contact/ContactClients.js";
import {
    AppBar,
    CssBaseline,
    Drawer,
    Hidden,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Typography,
    Toolbar
} from "@material-ui/core";
import {
    ChevronLeft,
    ChevronRight,
    InsertInvitation,
    Assignment,
    Print,
    Mail,
    Menu,
    School,
    Public
} from "@material-ui/icons";
import VideoIcon from "@material-ui/icons/OndemandVideo";
import FolderSharedIcon from "@material-ui/icons/FolderShared";
import ActionMenu from "./ActionMenu.js";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import PremiumBadge from "../Frequents/PremiumBadge.js";
import PremiumMessage from "../Alerts/PremiumMessage.js";
import VersionIndicator from "./VersionIndicator.js";
import { useHistory } from "react-router-dom";

import logo from "../../img/logoNoText.png";
import Copyright from "../Login/Copyright";
import DineroVerify from "../DineroVerify/DineroVerify.js";
import VideoGuide from "../VideoGuide/VideoGuide.js";
import { NewClientForm } from "../Calendar/index.js";

const useStyles = makeStyles(theme => ({
    root: {
        display: "flex",
        height: "100vh",
        overflowY: "hidden"
    },
    drawer: {
        [theme.breakpoints.up("sm")]: {
            width: drawerWidth => drawerWidth,
            flexShrink: 0
        }
    },
    appBar: {
        [theme.breakpoints.up("sm")]: {
            width: drawerWidth => `calc(100% - ${drawerWidth}px)`,
            marginLeft: drawerWidth => drawerWidth
        },
        backgroundColor: "#fff",
        boxShadow: "none",
        borderBottom: "1px solid #ccc"
    },
    menuButton: {
        marginRight: theme.spacing(2),
        [theme.breakpoints.up("sm")]: {
            display: "none"
        }
    },
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
        width: drawerWidth => drawerWidth,
        backgroundColor: theme.palette.primary.main
    },
    content: {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        overflowX: "hidden",
        overflowY: "auto"
    },
    logoContainer: {
        height: "64px",
        width: "59px",
        padding: "15px 10px 15px 10px"
    },
    logo: {
        backgroundColor: "#fff",
        borderRadius: "10px"
    },
    flex1: {
        flex: 1
    }
}));

export default props => {
    const history = useHistory();
    const { container } = props;
    const [drawerWidth, setDrawerWidth] = useState(60);
    const classes = useStyles(drawerWidth);
    const theme = useTheme();
    const [mobileOpen, setMobileOpen] = useState(false);
    const [locationName, setLocationName] = useState("Kalender");
    const [premiumAlert, setPremiumAlert] = useState(false);
    const therapist = useSelector(state => state.data.therapist);

    const handleDrawerToggle = () => {
        setDrawerWidth(240);
        setMobileOpen(!mobileOpen);
    };

    useEffect(() => {
        const t = window.setTimeout(() => API.setTherapist(therapist), 1000);
        return () => window.clearTimeout(t);
    }, [therapist]);

    if (therapist.plan === "other") return <>Dit abonnement er ugyldigt. Kontakt evt. info@handsonbooking.dk</>;
    const drawer = (
        <>
            <div>
                <div className={classes.toolbar}>
                    <div className={classes.logoContainer}>
                        <img
                            src={therapist.logo || logo}
                            className={classes.logo}
                            height="100%"
                            width="100%"
                            alt="Logo"
                        />
                    </div>
                </div>
                <List style={{ overflowX: "hidden" }}>
                    {[
                        "Kalender",
                        "Klientdata",
                        "Faktura",
                        "Kontakt",
                        "Kursus",
                        "Online Booking" /*, "Samarbejde"*/,
                        "Video Guides"
                    ].map((text, index) => (
                        <ListItem
                            button
                            key={text}
                            onClick={() => {
                                if (
                                    therapist.plan === "light" &&
                                    ["Faktura", "Kontakt", "Kursus", "Online Booking", "Video Guides"].includes(text)
                                ) {
                                    setPremiumAlert(true);
                                    return;
                                }
                                setLocationName(text);
                                if (text === "Online Booking") text = "OnlineBookingSettings";
                                if (text === "Video Guides") text = "VideoGuide";
                                history.push("/" + text);
                            }}>
                            <ListItemIcon>
                                {
                                    [
                                        <InsertInvitation style={{ color: "#fff" }} />,
                                        <Assignment style={{ color: "#fff" }} />,
                                        <Print style={{ color: "#fff" }} />,
                                        <Mail style={{ color: "#fff" }} />,
                                        <School style={{ color: "#fff" }} />,
                                        <Public style={{ color: "#fff" }} />,
                                        <VideoIcon style={{ color: "#fff" }} />,
                                        <FolderSharedIcon style={{ color: "#fff" }} />
                                    ][index]
                                }
                            </ListItemIcon>
                            {drawerWidth !== 60 && <ListItemText style={{ color: "#fff" }} primary={text} />}
                            {therapist.plan === "light" &&
                                ["Faktura", "Kontakt", "Kursus", "Online Booking", "Video Guides"].includes(text) && (
                                    <PremiumBadge />
                                )}
                        </ListItem>
                    ))}
                </List>
            </div>
        </>
    );

    return (
        <div className={classes.root}>
            <CssBaseline />
            <AppBar position="fixed" className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        className={classes.menuButton}>
                        <Menu style={{ color: "black" }} />
                    </IconButton>
                    <Typography variant="h6" noWrap style={{ color: "black", flexGrow: 1 }}>
                        {locationName}
                    </Typography>
                    {/* <VersionIndicator /> */}
                    <ActionMenu />
                </Toolbar>
            </AppBar>
            <nav className={classes.drawer} aria-label="mailbox folders">
                <Hidden smUp implementation="css">
                    <Drawer
                        container={container}
                        variant="temporary"
                        anchor={theme.direction === "rtl" ? "right" : "left"}
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        classes={{
                            paper: classes.drawerPaper
                        }}
                        style={{ backgroundColor: "red !important" }}
                        ModalProps={{
                            keepMounted: true
                        }}>
                        {drawer}
                    </Drawer>
                </Hidden>
                <Hidden xsDown implementation="css">
                    <Drawer
                        classes={{
                            paper: classes.drawerPaper
                        }}
                        variant="permanent"
                        open>
                        {drawer}
                        {drawerWidth === 60 ? (
                            <IconButton
                                color="inherit"
                                onClick={() => setDrawerWidth(240)}
                                style={{
                                    maxWidth: "60px",
                                    marginLeft: "auto",
                                    marginRight: "auto",
                                    marginTop: "auto"
                                }}>
                                <ChevronRight style={{ color: "#fff" }} />
                            </IconButton>
                        ) : (
                            <IconButton
                                color="inherit"
                                onClick={() => setDrawerWidth(60)}
                                style={{
                                    maxWidth: "60px",
                                    marginLeft: "auto",
                                    marginRight: "auto",
                                    marginTop: "auto"
                                }}>
                                <ChevronLeft style={{ color: "#fff" }} />
                            </IconButton>
                        )}
                    </Drawer>
                </Hidden>
            </nav>
            <main className={classes.content}>
                <div className={classes.toolbar} />
                <div className={classes.flex1}>
                    <Switch>
                        <Route path={"/Kalender"} exact component={CalendarComponent} />
                        <Route path={"/Klientdata"} exact component={Data} />
                        <Route path={"/Faktura"} exact component={Invoice} />
                        <Route
                            path={"/Kursus"}
                            exact
                            render={() => <Course setLocationName={() => setLocationName("Kursus")} />}
                        />
                        {/* <Route
                            path={"/Samarbejde"}
                            exact
                            render={() => <Cowork setLocationName={() => setLocationName("Samarbejde")} />}
                        /> */}
                        <Route
                            path={"/OnlineBookingSettings"}
                            exact
                            render={() => (
                                <OnlineBookingSettings
                                    setLocationName={() => setLocationName("Online Booking Indstillinger")}
                                />
                            )}
                        />
                        <Route
                            path={"/Kontakt"}
                            exact
                            render={() => (
                                <ContactClients setLocationName={() => setLocationName("Kontakt Klienter")} />
                            )}
                        />
                        <Route
                            path={"/VideoGuide"}
                            exact
                            render={() => (
                                <VideoGuide setLocationName={() => setLocationName("Handson Booking guides")} />
                            )}
                        />
                        <Route
                            path={"/Settings"}
                            exact
                            render={() => <Settings setLocationName={() => setLocationName("Firmaindstillinger")} />}
                        />
                        <Route path={"/dinero-verify"} exact render={() => <DineroVerify />} />
                        <Route
                            path={"/NewPassword"}
                            exact
                            render={() => <NewPassword setLocationName={() => setLocationName("Password")} />}
                        />
                        <Route
                            path={"/Treatments"}
                            exact
                            render={() => <Treatments setLocationName={() => setLocationName("Behandlinger")} />}
                        />
                        <Route
                            path={"/NewClientForm"}
                            exact
                            render={() => <NewClientForm setLocationName={() => setLocationName("Tilføj ny klient")} />}
                        />
                        <Redirect exact from="*" to="/Kalender" />
                    </Switch>
                    <PremiumMessage
                        open={premiumAlert}
                        handleClose={(e, reason) => {
                            if (reason !== "clickaway") setPremiumAlert(false);
                        }}
                        text="Kan kun bruges med pro abonnement"
                    />
                </div>
                <Copyright></Copyright>
            </main>
        </div>
    );
};
